import { useEffect, useState } from "react";
import { useLocation, type WindowLocation } from "@gatsbyjs/reach-router";
import {
  getWebStorageItem,
  removeWebStorageItem,
  setWebStorageItem
} from "./web-storage";

const featureEnabled = (name: string) => `${name}=true`;
const featureDisabled = (name: string) => `${name}=false`;

const activeFeatureFlags = [
  "showFaresSection",
  "new-offer-cards",
  "fully-refundable-fares"
] as const;
type ActiveFeatureFlags = (typeof activeFeatureFlags)[number];

export const useClientSideFeatureFlag = (name: ActiveFeatureFlags) => {
  const [isEnabled, setIsEnabled] = useState(false);
  const location = useLocation();
  const search = location.search;

  useEffect(() => {
    if (search.includes(featureEnabled(name))) {
      setWebStorageItem("local", name, "true");
      setIsEnabled(true);
      return;
    }
    if (search.includes(featureDisabled(name))) {
      removeWebStorageItem("local", name);
      setIsEnabled(false);
      return;
    }
    if (getWebStorageItem("local", name) === "true") {
      setIsEnabled(true);
      return;
    }
  }, [name, search]);

  return isEnabled;
};

export const useCruiseMarketNameEnabled = () =>
  isEnvFeatureEnabled(process.env.GATSBY_ENABLE_CRUISE_MARKET_NAMES);

export const isDev = (location: WindowLocation | undefined) =>
  isDevBuild() && location?.hostname == "localhost";

export const isDevBuild = () => process.env.NODE_ENV == "development";

export const isEnvFeatureEnabled = (
  envVariable: string | undefined
): boolean => {
  return (envVariable || "false").toLowerCase() === "true";
};
